import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatChipsModule } from '@angular/material/chips';
import { FormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { AlertComponent } from './alert/alert.component';
import { ToggleButtonsComponent } from './toggle-buttons/toggle-buttons.component';
import { AppSelectionTableComponent } from './selection-table/selection-table.component';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { MatSliderModule } from '@angular/material/slider';
import { ImageBackgroudComponent } from './image-backgroud/image-backgroud.component';
import { FeedbackAlertComponent } from './feedback-alert/alert.component';

@NgModule({
  declarations: [
    AlertComponent,
    FeedbackAlertComponent,
    ToggleButtonsComponent,
    AppSelectionTableComponent,
    ImageBackgroudComponent,
  ],
  imports: [
    CommonModule,
    MatChipsModule,
    FormsModule,
    MatButtonToggleModule,
    MatCardModule,
    MatTableModule,
    MatCheckboxModule,
    LeafletModule,
    MatSliderModule,
  ],
  exports: [
    AlertComponent,
    FeedbackAlertComponent,
    ToggleButtonsComponent,
    AppSelectionTableComponent,
    ImageBackgroudComponent,
  ],
})
export class SharedModule {}
